import './VendorLeadBillingInfoDone.scss';

import LogoText from 'src/assets/logo-text.svg?react';

export function VendorLeadBillingInfoDone() {
  return (
    <div className="vendor-lead-billing-info-done__layout">
      <div className="vendor-lead-billing-info-done__layout__left" />
      <div className="vendor-lead-billing-info-done__layout__center">
        <div className="vendor-lead-billing-info-done__layout__center__header">
          <div className="vendor-lead-billing-info-done__layout__center__header__logo">
            <div className="vendor-lead-billing-info-done__layout__center__header__logo-icon" />
            <LogoText className="vendor-lead-billing-info-done__layout__center__header__logo-text" />
          </div>
        </div>

        <div className="vendor-lead-billing-info-done__layout__center__content">
          <div className="vendor-lead-billing-info-done__layout__center__title">Thank you!</div>
          <div className="vendor-lead-billing-info-done__layout__center__text">&nbsp;</div>
        </div>
      </div>
      <div className="vendor-lead-billing-info-done__layout__right" />
    </div>
  );
}
